import { render, staticRenderFns } from "./smTableExpand.vue?vue&type=template&id=2864e58e&scoped=true&"
import script from "./smTableExpand.vue?vue&type=script&lang=js&"
export * from "./smTableExpand.vue?vue&type=script&lang=js&"
import style0 from "./smTableExpand.vue?vue&type=style&index=0&id=2864e58e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2864e58e",
  null
  
)

export default component.exports